import { connect } from "react-redux";

import { selectPagelessMarkedMaterials } from "~/store/selectors/dls";
import {
  selectIsPresentationMaterialVisible,
  selectIsPresentationActive
} from "~/store/ducks/user/uistate";

import NonAssignedPresentationMaterialsList from "./NonAssignedPresentationMaterialsList";

const mapStateToProps = state => ({
  isPresentationMaterialVisible: selectIsPresentationMaterialVisible(state),
  materials: selectPagelessMarkedMaterials(state),
  isPresentationActive: selectIsPresentationActive(state)
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NonAssignedPresentationMaterialsList);
